import { Skeleton } from '@systemeio/components';
import { defaultBrandSettings, getBrandFromLocalStorage, isClient } from '@systemeio/util';
import { useEffect, useState } from 'react';
import { useMetadataFromServer } from 'shared/hooks/use-metadata-from-server';
import { useChristmas } from 'shared/layout/components/snow/use-christmas';
import { isSIO } from 'shared/utils/is-sio';
import { twMerge } from 'tailwind-merge';
interface BrandLogoProps {
  className: string;
  loaderClassName: string;
}
export const BrandLogo = ({
  className,
  loaderClassName
}: BrandLogoProps) => {
  const [hydrated, setHydrated] = useState(false);
  const {
    data: metaDataFromServer
  } = useMetadataFromServer();
  const christmasFeatureIsOn = useChristmas();
  useEffect(() => {
    setHydrated(true);
  }, []);
  const getLogoImage = (src: string = christmasFeatureIsOn ? 'https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-christmas.png' : defaultBrandSettings.logo?.path, alt: string = defaultBrandSettings.name) => <img className={className} src={src} alt={alt} />;
  if (isSIO(metaDataFromServer?.hostOnServer)) {
    return getLogoImage();
  }
  if (isClient() && hydrated) {
    const brand = getBrandFromLocalStorage();
    if (brand) {
      return getLogoImage(brand.logo?.path, brand.name);
    }
  }
  return <Skeleton className={twMerge('rounded-full', loaderClassName)} />;
};